/**
 * 受付帳（ReceptionBook）用のタグ同期システム
 * PropertySelectionGridと受付帳ポップアップ間でタグデータを同期するためのユーティリティ
 */

import { createIndexedPropertyGridPopupSyncSystem } from "./createSyncSystem";

export const RECEPTION_BOOK_TAG_UPDATE_EVENT = "updateReceptionBookTags";

const { dispatch, addListener } = createIndexedPropertyGridPopupSyncSystem<
  string[]
>(RECEPTION_BOOK_TAG_UPDATE_EVENT);

/**
 * 受付帳のタグ更新イベントを発火する
 * ポップアップが開かれた際に最新のタグでフォームを更新するために使用
 * @param index 受付帳のインデックス
 * @param tags 更新するタグの配列
 */
export const dispatchReceptionBookTagUpdate = (
  index: number,
  tags: string[]
): void => {
  dispatch(index, tags);
};

/**
 * 受付帳のタグ更新イベントリスナーを追加する
 * @param targetIndex リスナーを登録する対象のインデックス
 * @param callback タグが更新された際に呼び出されるコールバック関数
 * @returns クリーンアップ関数
 */
export const addReceptionBookTagUpdateListener = (
  targetIndex: number,
  callback: (tags: string[]) => void
): (() => void) => {
  return addListener(targetIndex, callback);
};
